import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from '../components/footer/footer.component';
import { NavbarComponent } from '../components/navbar/navbar.component';
import { RouterModule } from '@angular/router';
import { NotificationComponent } from '../components/notification/notification.component';
import { TranslateModule } from '@ngx-translate/core';
import { ComparePremiumComponent } from '../components/compare-premium/compare-premium.component';

@NgModule({
  declarations: [
    NavbarComponent,
    FooterComponent,
    NotificationComponent,
    ComparePremiumComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule
  ],
  exports: [
    NavbarComponent,
    FooterComponent,
    NotificationComponent
  ]
})
export class SharedModule { }
